<template>
    <v-dialog v-model="openModal" max-width="450" content-class="confirm-delete-dialog">
        <v-card>
            <div class="header">
                <h3>{{ title || ($page.props.lang.confirmModalTitle || 'Confirmation') }}</h3>
                <v-btn @click="$emit('close')" icon><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <p v-html="description || ''" class="description">{{ description || '' }}</p>
                <v-radio-group
                v-model="radios" mandatory>
                <v-radio
                :label="noText"
                value="no"
                ></v-radio>
                <v-radio
                :label="yesText"
                value="yes"
                ></v-radio>
                </v-radio-group>
            <div class="buttons">
                <v-btn color="primary" @click="$emit(radios)">{{ ($page.props.lang.submit || 'Submit') }}</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ReccuringModal",
    props: {
        open: Boolean,
        title: String,
        description: String,
        noText: String,
        yesText: String
    },
    data(){
        return{
            radios:'no'
        }
    },
    computed: {
        openModal: {
            get: function() {
                return this.open
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    }
}
</script>